import { makeStyles } from '@mui/styles';
import Radio from 'apollo-react/components/Radio';
import RadioGroup from 'apollo-react/components/RadioGroup';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../../custom-hooks';
import { getUITA } from '../../../utils/commonUtils';
import { isNilOrEmpty } from '../../../utils/ramdaUtils';
import { fetchDataSource } from '../../actions/data-source.actions';
import RequiredIndicator from '../../components/RequiredIndicator';
import { PREDEFINED_DATA_SOURCES } from '../../constants/form-manager.constants';
import { getDataSource } from '../../selectors/form-manager.selectors';
import { getDataSourceWatchValues } from '../../selectors/runtime.selectors';
import { equalityFn, getOpitonsForPredefinedDataSource } from '../../utils/form-manager.utils';

const useStyles = makeStyles({
  requiredIndicatorInTableContainer: {
    width: '16px',
    paddingTop: '10px',
    position: 'absolute',
    top: '15px',
    left: '-10px',
  },
});

function SSRuntimeRadioButtonList({
  label,
  value,
  actions,
  isRequired,
  dataSourceKey,
  dataValueField,
  dataTextField,
  dataSourceFilter,
  error,
  index,
  inFieldGroup,
  isHiddenLabel,
  formKey,
  instanceId,
  entityName,
  fieldName,
  disabled,
  inTable,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const dataSource = useFormSelector(getDataSource, { dataSourceKey }, equalityFn) || {};
  const watchValues = useFormSelector(
    getDataSourceWatchValues,
    {
      conditions: dataSourceFilter?.Conditions || [],
      dataSource,
      index,
      entityName,
    },
    equalityFn
  );
  const [values, setValues] = useState([]);

  const pageLimit = 1;
  const isDataSourcePredefined = PREDEFINED_DATA_SOURCES.includes(dataSourceKey);
  const hiddenLabel = inTable || (inFieldGroup && isHiddenLabel);
  const valueStr = _.isNil(value) ? '' : value.toString();

  // fetch data from dataSource
  useEffect(() => {
    if (!isNilOrEmpty(dataSource) && !isDataSourcePredefined) {
      dispatch(
        fetchDataSource({
          index,
          dataSource,
          dataSourceFilter,
          dataSourceFilterFromDataSource: dataSource.filter,
          formKey,
          pageLimit,
          entityName,
          isEditor: false,
        })
      ).then((vals) => setValues(vals.filter((item) => item[dataTextField])));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...watchValues, `${index}`]);

  // fetch data from redux store if data source is predefined
  useEffect(() => {
    if (isDataSourcePredefined) {
      const _values = getOpitonsForPredefinedDataSource(dataSource, dataSourceKey);
      setValues(_values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = ({ target: { value } }) => {
    actions.updateControlValue(value);
  };

  return (
    <div
      style={{ marginTop: 16 }}
      ui-ta={getUITA('FormCtrl', 'SSRadioButtonList', entityName, fieldName)}
    >
      {hiddenLabel && isRequired && (
        <span className={inTable ? classes.requiredIndicatorInTableContainer : {}}>
          <RequiredIndicator />
        </span>
      )}
      <RadioGroup
        id={instanceId}
        tabIndex={0}
        label={hiddenLabel ? '' : label}
        value={valueStr}
        onChange={onChange}
        row
        required={isRequired}
        error={error}
        disabled={disabled}
      >
        {values.map((item, i) =>
          isDataSourcePredefined ? (
            <Radio key={item.id} value={item.value} label={item.label} />
          ) : (
            <Radio
              key={`${item[dataTextField]}_${item[dataValueField]}_${i}`}
              value={item[dataValueField]}
              label={item.LNG_TRANSLATION || item[dataTextField]}
            />
          )
        )}
      </RadioGroup>
    </div>
  );
}

export default SSRuntimeRadioButtonList;
